import FilterSelect, {
    FilterSelectOptionType,
} from "@jmc/solid-design-system/src/components/molecules/FilterSelect/FilterSelect";
import React from "react";
import { useTranslation } from "react-i18next";
import { connectRefinementList } from "react-instantsearch-dom";

import { useLocatorContext } from "../LocatorContext/LocatorContext";
import SpecialtyFilterType from "../types/SpecialtyFilterType";

const SpecialtyList = ({
    items,
    refine,
}: {
    items: { count: number; isRefined: boolean; label: string; value: string[] }[];
    refine: (value: string[]) => void;
}): JSX.Element => {
    const { t } = useTranslation();
    const { specialtyFilter, setSpecialtyFilter } = useLocatorContext();

    let removedOne = false;
    let selectedOptionCount = 0;
    const sortedItems = items?.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
    const filterOptions = sortedItems?.map((item, index: number) => {
        const filter = {
            label: `${item.label} (${item.count})`,
            value: JSON.stringify(item.value),
            isSelected: item.isRefined,
        } as SpecialtyFilterType;

        // We can only remove one filter at a time, cause the refine function will trigger another render.
        if (specialtyFilter[index]?.deleted) {
            filter.deleted = true;
            if (item.isRefined && !removedOne) {
                refine(item.value);
                filter.deleted = false;
                removedOne = true;
            }
        }

        if (item.isRefined) selectedOptionCount++;

        return filter;
    });

    if (JSON.stringify(specialtyFilter) !== JSON.stringify(filterOptions)) {
        setSpecialtyFilter(filterOptions);
    }

    return (
        <FilterSelect
            id="Specialty"
            key={0}
            customClass={null}
            placeholder={
                selectedOptionCount > 0
                    ? `${t("Specialty", { ns: "common" })} (${selectedOptionCount})`
                    : `${t("Specialty", { ns: "common" })}`
            }
            options={filterOptions}
            isMulti={true}
            clickAction={(items: FilterSelectOptionType) => {
                if (items?.length) {
                    return refine([]);
                } else {
                    return refine(JSON.parse(items.value));
                }

                //
            }}
        />
    );
};

const SpecialtyFilter = connectRefinementList(SpecialtyList);

export default SpecialtyFilter;
